// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_staticHeader__Mw7jW {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: transparent;
    z-index: 2;
}

.header_scrollingHeader__xzulC {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff !important;
    z-index: 99;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1) !important;
}
.header_mainSection__3twbz {
    display: flex;
    justify-content: space-between;
    padding: 0px 5%;
}
.header_logo__GzeFQ {
    position: relative;
    top: 20px;
    width: 62%;
}
.header_poweredBy__-w-H4 {
    color: gray;
    font-size: 0.75em;
    display: flex;
    align-items: top;
    gap: 5px;
}
.header_msLogo__hbX6f {
    width: 100px;    
}
.header_getStartedButton__a9RgW {
    background-color: #69bf4a;
    color: #fff;
    padding: 5px 50px 15px 50px;
    border-radius: 0px 0px 20px 20px;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 0;
    margin-top: 0;
    text-align: center;
    white-space: nowrap;
}
.header_glow__K64cn {
    box-shadow: 0 0 30px #00ff00;
}
.header_buttonsHeader__p0Daz {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 25px;
    margin: 0.5em 0;
}
.header_numberText__CrFXW {
    font-weight: bold;
    font-size: 20px;
    color: #69bf4a;
}
.header_numberText__CrFXW a {
    text-decoration: none;
    color: #69bf4a;
    cursor: pointer;
}


@media screen and (max-width: 992px) {
    .header_logo__GzeFQ {
        width: 45%;
    }
}

@media screen and (max-width: 850px) {
    .header_getStartedButton__a9RgW {
        padding: 7px 3px 10px 3px;
        font-size: 18px;
    }
    .header_buttonsHeader__p0Daz {
        gap: 8px;
    }
    .header_numberText__CrFXW {
        font-size: 16px;
    }
    .header_messageIcon__x9t43 {
        width: 22px;
    }
    .header_tb2Logo__RpXrb {
        width: 100px;
    }
    .header_msLogo__hbX6f {
        width: 75px;    
    }
    .header_poweredBy__-w-H4 {
        font-size: 0.5em;
    }
}

@media screen and (max-width: 682px) {
    .header_tb2Logo__RpXrb {
        width: 75px;
    }
    .header_msLogo__hbX6f {
        width: 50px;    
    }
    .header_poweredBy__-w-H4 {
        font-size: 0.5em;
    }
}

@media screen and (max-width: 522px){
    .header_mainSection__3twbz {
        padding: 0px 2%;
    }
    .header_logo__GzeFQ {
        top: 5px;
    }
}

@media screen and (max-width: 360px) {
    .header_getStartedButton__a9RgW {
        padding: 1px 10px 3px 10px;
        font-size: 14px;
    }
    .header_tb2Logo__RpXrb {
        width: 55px;
    }
    .header_msLogo__hbX6f {
        width: 35px;    
    }
}`, "",{"version":3,"sources":["webpack://./src/components/.shared/header.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,iCAAiC;IACjC,WAAW;IACX,qDAAqD;AACzD;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,QAAQ;AACZ;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,2BAA2B;IAC3B,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB;;;AAGA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,eAAe;IACnB;IACA;QACI,QAAQ;IACZ;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":[".staticHeader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: transparent;\n    z-index: 2;\n}\n\n.scrollingHeader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #fff !important;\n    z-index: 99;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1) !important;\n}\n.mainSection {\n    display: flex;\n    justify-content: space-between;\n    padding: 0px 5%;\n}\n.logo {\n    position: relative;\n    top: 20px;\n    width: 62%;\n}\n.poweredBy {\n    color: gray;\n    font-size: 0.75em;\n    display: flex;\n    align-items: top;\n    gap: 5px;\n}\n.msLogo {\n    width: 100px;    \n}\n.getStartedButton {\n    background-color: #69bf4a;\n    color: #fff;\n    padding: 5px 50px 15px 50px;\n    border-radius: 0px 0px 20px 20px;\n    font-weight: bold;\n    font-size: 20px;\n    margin-bottom: 0;\n    margin-top: 0;\n    text-align: center;\n    white-space: nowrap;\n}\n.glow {\n    box-shadow: 0 0 30px #00ff00;\n}\n.buttonsHeader {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 25px;\n    margin: 0.5em 0;\n}\n.numberText {\n    font-weight: bold;\n    font-size: 20px;\n    color: #69bf4a;\n}\n.numberText a {\n    text-decoration: none;\n    color: #69bf4a;\n    cursor: pointer;\n}\n\n\n@media screen and (max-width: 992px) {\n    .logo {\n        width: 45%;\n    }\n}\n\n@media screen and (max-width: 850px) {\n    .getStartedButton {\n        padding: 7px 3px 10px 3px;\n        font-size: 18px;\n    }\n    .buttonsHeader {\n        gap: 8px;\n    }\n    .numberText {\n        font-size: 16px;\n    }\n    .messageIcon {\n        width: 22px;\n    }\n    .tb2Logo {\n        width: 100px;\n    }\n    .msLogo {\n        width: 75px;    \n    }\n    .poweredBy {\n        font-size: 0.5em;\n    }\n}\n\n@media screen and (max-width: 682px) {\n    .tb2Logo {\n        width: 75px;\n    }\n    .msLogo {\n        width: 50px;    \n    }\n    .poweredBy {\n        font-size: 0.5em;\n    }\n}\n\n@media screen and (max-width: 522px){\n    .mainSection {\n        padding: 0px 2%;\n    }\n    .logo {\n        top: 5px;\n    }\n}\n\n@media screen and (max-width: 360px) {\n    .getStartedButton {\n        padding: 1px 10px 3px 10px;\n        font-size: 14px;\n    }\n    .tb2Logo {\n        width: 55px;\n    }\n    .msLogo {\n        width: 35px;    \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"staticHeader": `header_staticHeader__Mw7jW`,
	"scrollingHeader": `header_scrollingHeader__xzulC`,
	"mainSection": `header_mainSection__3twbz`,
	"logo": `header_logo__GzeFQ`,
	"poweredBy": `header_poweredBy__-w-H4`,
	"msLogo": `header_msLogo__hbX6f`,
	"getStartedButton": `header_getStartedButton__a9RgW`,
	"glow": `header_glow__K64cn`,
	"buttonsHeader": `header_buttonsHeader__p0Daz`,
	"numberText": `header_numberText__CrFXW`,
	"messageIcon": `header_messageIcon__x9t43`,
	"tb2Logo": `header_tb2Logo__RpXrb`
};
export default ___CSS_LOADER_EXPORT___;
